import { render, staticRenderFns } from "./IllustrationTop.vue?vue&type=template&id=9af6f4d8&"
import script from "./IllustrationTop.vue?vue&type=script&lang=js&"
export * from "./IllustrationTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports